<template>
  <span class="grab-control icon-drag-handler d-inline-block" @mousedown="emitStart" @touchstart.passive="emitStart"></span>
</template>

<script>
export default {
  name: 'grab-control',

  methods: {
    emitStart (e) {
      this.$emit('grabstart', e)
    },

    emitEnd (e) {
      this.$emit('grabend', e)
    }
  },

  mounted () {
    window.addEventListener('mouseup', this.emitEnd)
    window.addEventListener('touchend', this.emitEnd)
  },

  beforeDestroy () {
    window.removeEventListener('mouseup', this.emitEnd)
    window.removeEventListener('touchend', this.emitEnd)
  }
}
</script>

<style lang="scss">
  .grab-control {
    cursor: grabbing;
    font-size: 2.3rem;
    /*margin-top: .11rem;*/
  }
</style>
